import en from './en'
import he from './he'
export default { en, he }
